<!-- 认证审核、已认证、认证失败 -->
<template>
  <div class="wrapper">
    <div v-if="state == 1" class="underReview">
      <img src="@/assets/underReview.png" class="underReview_img">
      <div class="underReview_text">您的资料已提交，请耐心等待审核</div>
      <div class="underReview_tips">预计3个工作日内完成认证审核</div>
    </div>
    <div v-if="state == 2" class="certified">
      <div class="mr_b32">
        <div class="certified_title">企业信息</div>
        <el-row :gutter="20" class="mr_b16">
          <el-col :span="8">
            <div><span class="label">企业名称：</span><span class="value">{{customerDetail.customerName}}</span><span class="state" v-if="status == 2"><img src="@/assets/certified.png" alt="" class="state_img"></span></div>
          </el-col>
          <el-col :span="8">
            <div><span class="label">统一社会信用代码：</span><span class="value">{{customerDetail.creditCode}}</span></div>
          </el-col>
          <el-col :span="8">
            <div><span class="label">住所/经营场所：</span>
              <!-- <span class="value">{{customerDetail.address}}</span> -->
              <table-column-decrypt  :key="Math.random()" class="value" :decrypt-dto="customerDetail.addressDto" :src-value="customerDetail.address" />
            </div>
          </el-col>

        </el-row>
        <el-row :gutter="20">
          <el-col :span="8" v-if="customerDetail.companyType == 2">
            <div><span class="label">公司性质：</span><span class="value">{{{1:"母公司",2:"子公司"}[customerDetail.companyType]}}</span></div>
          </el-col>
          <el-col :span="8" v-if="customerDetail.companyType == 2 && customerDetail.mentorName">
            <div><span class="label">关联母公司名称：</span><span class="value">{{customerDetail.mentorName}}</span></div>
          </el-col>
        </el-row>
      </div>
      <div class="certified_title">法人信息</div>
      <el-row :gutter="20" class="mr_b16">
        <el-col :span="8">
          <div><span class="label">法人姓名：</span><span class="value">{{customerDetail.corporaName}}</span></div>
        </el-col>
        <el-col :span="8">
          <div><span class="label">身份证号：</span>
            <!-- <span class="value">{{customerDetail.corporaIdNumber}}</span> -->
            <table-column-decrypt  :key="Math.random()" class="value" :decrypt-dto="customerDetail.corporaIdNumberDto" :src-value="customerDetail.corporaIdNumber" />
          </div>
        </el-col>
        <el-col :span="8">
          <div><span class="label">手机号：</span>
            <!-- <span class="value">{{customerDetail.corporaPhone}}</span> -->
            <table-column-decrypt  :key="Math.random()" class="value" :decrypt-dto="customerDetail.corporaPhoneDto" :src-value="customerDetail.corporaPhone" />
          </div>
        </el-col>

      </el-row>

    </div>
    <div v-if="state == 3" class="authentication_failed">
      <el-card class="authentication_failed_container">
        <div class="authentication_failed_header">
          <div class="authentication_failed_header_text mr_b16"> <img src="@/assets/rzfail.png" class="authentication_failed_header_img"> 认证失败！请阅读失败原因并进行资料修改</div>
          <div class="authentication_failed_header_tips mr_b32">失败原因：<span>{{failText}}</span></div>
        </div>
        <div class="mr_b32">
          <div class="certified_title">企业信息</div>
          <el-row :gutter="20" class="mr_b16">
            <el-col :span="8">
              <div><span class="label">企业名称：</span><span class="value">{{customerDetail.customerName}}</span></div>
            </el-col>
            <el-col :span="8">
              <div><span class="label">统一社会信用代码：</span><span class="value">{{customerDetail.creditCode}}</span></div>
            </el-col>
            <el-col :span="8">
              <div><span class="label">注册资本：</span><span class="value">{{customerDetail.registerCapital}}万元</span></div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="mr_b16">
            <el-col :span="8">
              <div><span class="label">成立时间：</span><span class="value">{{customerDetail.registerDate | timeFilter}}</span></div>
            </el-col>
            <el-col :span="8">
              <div><span class="label">营业期限：</span><span class="value">{{customerDetail.registerDateStart | timeFilter}}-{{registerDateEndFormat}}</span></div>
            </el-col>
            <el-col :span="8">
              <div><span class="label">住所/经营场所：</span>
                <!-- <span class="value">{{customerDetail.address}}</span> -->
                <table-column-decrypt  :key="Math.random()" class="value" :decrypt-dto="customerDetail.addressDto" :src-value="customerDetail.address" />
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="mr_b16">
            <el-col :span="8">
              <div><span class="label">营业执照：</span><i class="el-icon-paperclip"></i> <span class="value" @click="linkFile(customerDetail.businessLicenseFileAddr)">营业执照</span></div>
            </el-col>
            <el-col :span="8" v-if="customerDetail.companyType == 2">
              <div><span class="label">公司性质：</span><span class="value">{{{1:"母公司",2:"子公司"}[customerDetail.companyType]}}</span></div>
            </el-col>
            <el-col :span="8" v-if="customerDetail.companyType == 2">
              <div><span class="label">关联母公司名称：</span><span class="value">{{customerDetail.mentorName}}</span></div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" v-if="customerDetail.companyType == 2">
              <div><span class="label">证明材料：</span><i class="el-icon-paperclip"></i> <span class="value" @click="linkFile(customerDetail.mentorProveFileAddr)">关联母公司证明材料证明材料</span></div>
            </el-col>
          </el-row>
        </div>
        <div class="mr_b32">
          <div class="certified_title">法人信息</div>
          <el-row :gutter="20" class="mr_b16">
            <el-col :span="8">
              <div><span class="label">法人与账户注册人为同一人：</span><span class="value">{{{1:"是",0:"否"}[customerDetail.registerPersonFlag]}}</span></div>
            </el-col>
            <el-col :span="8">
              <div><span class="label">法人姓名：</span><span class="value">{{customerDetail.corporaName}}</span></div>
            </el-col>
          </el-row>
        </div>
        <el-divider></el-divider>
        <div class="mr_24">
          <div class="certified_title">开户许可证</div>
          <el-row :gutter="20" class="mr_b16">
            <el-col :span="8">
              <div><span class="label">银行名称：</span><span class="value">{{customerDetail.bankName}}</span></div>
            </el-col>
            <el-col :span="8">
              <div><span class="label">银行账户：</span><span class="value">{{customerDetail.bankAccount}}</span></div>
            </el-col>
            <el-col :span="8">
              <div><span class="label">开户许可证：</span><i class="el-icon-paperclip"></i> <span class="value" @click="linkFile(customerDetail.accountOpeningFileAddr)">开户许可证</span></div>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <el-card class="mr_t">
        <div class="btn">
          <el-button type="primary" @click="modify">修改</el-button>
        </div>
      </el-card>
    </div>
    <el-drawer title="" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
      <el-image	style="width: 100%; height: auto" :src="url"  :preview-src-list="srcList">
      </el-image>
    </el-drawer>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
import getMvcUrl from "../../../utils/mvcUrlUtil.js";
import tableColumnDecrypt from '@/components/table-column-decrypt.vue';
export default {
  components: {
    tableColumnDecrypt
  },
  data() {
    return {
      state: 1,
      status: "",
      customerDetail: {},
      drawer: false,
      srcList: [],
      direction: 'rtl',
      url: null,
      failText:""
    }
  },
  filters: {
    timeFilter(val) {
      if (val) {
        var v = moment(new Date(val)).format("YYYY-MM-DD");
        return v;
      }
    },
  },
  mounted() {
    this.queryByCustomerNo();
  },

  computed: {
    registerDateEndFormat() {
      if(this.customerDetail.registerDateType == 1){
        return '长期';
      }else{
        return this.customerDetail.registerDateEnd ? moment(new Date(this.customerDetail.registerDateEnd)).format("YYYY-MM-DD") : '';
      }
    },
  },
  methods: {
    ...mapActions([
      "queryByCustomerNoAPI",
    ]),
    //修改
    modify(){
       this.$emit("jumpStep", 4);
    },
    // 状态，0：未提交审核 1：提交资料，2-审核通过，3-审核驳回，4-失效，5-sap申请中, 6-个人实名认证-未完成， 7-个人实名认证-已完成，注：当status=0,1,2,3,4,5是否，实名认证是已经开通的，如果status=6，7时候，企业实名认证未开通
    queryByCustomerNo() {
      // 进入页面回显相关信息
      let params = {
        customerNo: JSON.parse(sessionStorage.getItem("userInfo")).customerNo,
      };
      this.queryByCustomerNoAPI(params).then((res) => {
        let { customerDetail, historyList } = res;
        this.status = customerDetail.status;
        this.customerDetail = customerDetail;
        this.failText = historyList[0].updateResult;
        switch (this.status) {
          case 2:
            this.state = 2;
            break;
          case 3:
            this.state = 3;
            break;
          default:
            this.state = 1;
            break;
        }
      });
    },
    handleClose(done) {
      done();
    },
    linkFile(filename) {
      if (!filename) {
        this.$message({ type: "error", message: '文件不存在！' });
        return;
      }
      if (this.calcIconType(filename) === 'img') {
        this.drawer = true;
        this.switchImg(filename);
      } else {
        this.fileDownLoad(filename);
      }
    },
    calcIconType(v) {
      if (v) {
        let imgs = ['jpg', 'jpeg', 'gif', 'png', 'bmp'];
        for (let i = 0; i < imgs.length; i++) {
          if (v.toLowerCase().indexOf('.' + imgs[i]) > 0) {
            return 'img';
          }
        }
      }
      return 'file';
    },
    switchImg(filename) {
      let preUrl = getMvcUrl() + '/saas/companyQualification/viewImage?objectName=';
      this.url = preUrl + filename;
      this.srcList = [this.url];
    },
    fileDownLoad(filename) {
      let preUrl = getMvcUrl() + '/saas/companyQualification/downLoadFile?objectName=' + filename;
      window.open(preUrl);
    },
  }
}
</script>
<style lang="less" scoped>
.wrapper {
  .underReview {
    text-align: center;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translateY(-50%);
    .underReview_img {
      width: 349.32px;
      height: 269.59px;
    }
    .underReview_text {
      margin-top: 37px !important;
      font-size: 16px;
      color: #000000;
      letter-spacing: 0;
      line-height: 25.92px;
      font-weight: 500;
    }
    .underReview_tips {
      margin-top: 10px !important;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      line-height: 23.76px;
      font-weight: 400;
    }
  }
  .certified {
    padding: 32px !important;
  }
  .authentication_failed {
    .authentication_failed_container {
      padding: 32px 32px 100px 32px !important;
    }
    .authentication_failed_header {
      color: #dc1e32;
      &_text {
        font-size: 20px;
        letter-spacing: 0;
        font-weight: bold;
      }
      &_tips {
        font-size: 16px;
        letter-spacing: 0;
        font-weight: 400;
      }
      &_img {
        width: 24px;
        height: 24px;
        margin: 0 8px -2px 0 !important;
      }
    }
  }
  .certified_title {
    margin-bottom: 16px !important;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    font-weight: bold;
  }
  .label {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
    font-weight: 400;
    opacity: 0.65;
  }
  .value {
    font-size: 14px;
    color: #000000;
    line-height: 22px;
    font-weight: 400;
  }
  .state {
    font-size: 12px;
    color: #111111;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    margin-left: 5px !important;
  }
  .state_img {
    width: 62px;
    height: 18px;
    vertical-align: bottom;
  }
  .mr_b16 {
    margin-bottom: 16px !important;
  }
  .mr_b32 {
    margin-bottom: 32px !important;
  }
  .mr_24 {
    margin: 32px 0 !important;
  }
  .mr_t {
    margin-top: 24px !important;
  }
  .btn {
    padding: 24px 32px !important;
    text-align: right;
  }
}
</style>